import { render, staticRenderFns } from "./AddMeasurement.vue?vue&type=template&id=f272bfde&scoped=true&"
import script from "./AddMeasurement.vue?vue&type=script&lang=js&"
export * from "./AddMeasurement.vue?vue&type=script&lang=js&"
import style0 from "./AddMeasurement.vue?vue&type=style&index=0&id=f272bfde&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f272bfde",
  null
  
)

export default component.exports